// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33SMu","colBig":"styles_colBig__o7mKI","colSmall":"styles_colSmall__155dp"};